<div *ngIf="currency$ | async as currency" class="a-fx-col a-fx-gap-24">
    <nz-tabset class="adspt-tab-table">
        <nz-tab
            *ngFor="let plan of previewSubscriptions$ | async"
            [nzTitle]="'settings.customer-subscription.plans.' + plan.type | translate"
        >
            <table *ngIf="(pricingExamples$ | async)?.[plan.type] as planData" class="pricing-table a-color-primary">
                <colgroup>
                    <col />
                    <col />
                    <col />
                </colgroup>
                <tbody>
                    <tr>
                        <td>
                            <strong>
                                {{ 'common.month-uppercase-first' | translate }}
                            </strong>
                        </td>
                        <td>
                            {{ months[7] }}
                        </td>
                        <td>
                            {{ months[8] }}
                        </td>
                    </tr>

                    <tr>
                        <td>
                            <strong>{{ 'settings.customer-subscription.fee' | translate }}</strong>
                        </td>
                        <ng-container *ngTemplateOutlet="feeTdTmpl; context: { fee: planData.fee }"></ng-container>
                        <ng-container *ngTemplateOutlet="feeTdTmpl; context: { fee: planData.fee }"></ng-container>
                    </tr>

                    <tr>
                        <td>
                            <strong>
                                {{ 'settings.customer-subscription.platform-s' | translate }}
                            </strong>
                        </td>
                        <ng-container
                            *ngTemplateOutlet="accountsTdTmpl; context: { accounts: planData.firstMonth }"
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="accountsTdTmpl; context: { accounts: planData.secondMonth }"
                        ></ng-container>
                    </tr>

                    <tr>
                        <td>
                            <strong>
                                {{ 'settings.billing.attributed-sales' | translate }}
                            </strong>
                        </td>
                        <ng-container
                            *ngTemplateOutlet="paidSalesTdTmpl; context: { accounts: planData.firstMonth }"
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="paidSalesTdTmpl; context: { accounts: planData.secondMonth }"
                        ></ng-container>
                    </tr>

                    <tr>
                        <td>
                            <strong>
                                {{ 'settings.customer-subscription.scale-applied' | translate }}
                            </strong>
                        </td>
                        <ng-container
                            *ngTemplateOutlet="scaleTdTmpl; context: { accounts: planData.firstMonth }"
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="scaleTdTmpl; context: { accounts: planData.secondMonth }"
                        ></ng-container>
                    </tr>

                    <tr *ngIf="plan.type !== AdspertPlanType.Essential">
                        <td>
                            <strong>
                                {{ 'settings.customer-subscription.aggregated-monthly-ad-spend' | translate }}
                            </strong>
                        </td>
                        <ng-container
                            *ngTemplateOutlet="adSpendTdTmpl; context: { accounts: planData.firstMonth }"
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="adSpendTdTmpl; context: { accounts: planData.secondMonth }"
                        ></ng-container>
                    </tr>

                    <tr>
                        <td>
                            <strong>
                                {{ 'settings.customer-subscription.final-price-calculation' | translate }}
                            </strong>
                        </td>
                        <ng-container
                            *ngTemplateOutlet="priceCalcTdTmpl; context: { month: 'firstMonth' }"
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="priceCalcTdTmpl; context: { month: 'secondMonth' }"
                        ></ng-container>
                    </tr>

                    <tr class="invoice">
                        <td>
                            <strong> {{ 'settings.customer-subscription.invoice' | translate }} </strong>&ngsp; ({{
                                'settings.customer-subscription.monthly-plan' | translate
                            }})
                        </td>
                        <ng-container
                            *ngTemplateOutlet="
                                invoiceTdCalc;
                                context: { month: 'firstMonth', period: SubscriptionInvoicePeriod.Monthly }
                            "
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="
                                invoiceTdCalc;
                                context: { month: 'secondMonth', period: SubscriptionInvoicePeriod.Monthly }
                            "
                        ></ng-container>
                    </tr>

                    <tr>
                        <td>
                            <strong> {{ 'settings.customer-subscription.invoice' | translate }} </strong>&ngsp; ({{
                                'settings.customer-subscription.yearly-plan'
                                    | translate: { discount: getSubscriptionDiscount(plan) | percent: '1.0-0' }
                            }})
                        </td>
                        <ng-container
                            *ngTemplateOutlet="
                                invoiceTdCalc;
                                context: { month: 'firstMonth', period: SubscriptionInvoicePeriod.Yearly }
                            "
                        ></ng-container>
                        <ng-container
                            *ngTemplateOutlet="
                                invoiceTdCalc;
                                context: { month: 'secondMonth', period: SubscriptionInvoicePeriod.Yearly }
                            "
                        ></ng-container>
                    </tr>
                </tbody>

                <ng-template let-fee="fee" #feeTdTmpl>
                    <td>
                        <ng-container *ngTemplateOutlet="currencyTmpl; context: { value: fee }"></ng-container>
                    </td>
                </ng-template>

                <ng-template let-accounts="accounts" #accountsTdTmpl>
                    <td>{{ getAccountsLabel(accounts) }}</td>
                </ng-template>

                <ng-template let-accounts="accounts" #paidSalesTdTmpl>
                    <td *ngIf="getPaidSales(accounts) as paidSales">
                        <ng-container
                            *ngTemplateOutlet="currencySummationTmpl; context: { values: paidSales }"
                        ></ng-container>
                    </td>
                </ng-template>

                <ng-template let-accounts="accounts" #scaleTdTmpl>
                    <td *ngIf="getScale(accounts, plan) as scale">
                        <div class="a-fx-col a-fx-gap-4">
                            <span>{{ scale.percentage | percent: '1.2-2' }}</span>
                        </div>

                        <div class="a-text-cap1 p2">
                            {{
                                'settings.customer-subscription.aggregated-monthly-paid-sales'
                                    | translate
                                        : {
                                              percentage: scale.percentage | percent: '1.2-2',
                                              threshold:
                                                  scale.threshold
                                                  | microsToNumber
                                                  | currency: currency : 'symbol' : '1.0-0',
                                              ceiling:
                                                  scale.ceiling
                                                  | microsToNumber
                                                  | currency: currency : 'symbol' : '1.0-0',
                                          }
                            }}
                        </div>
                    </td>
                </ng-template>

                <ng-template let-accounts="accounts" #adSpendTdTmpl>
                    <td *ngIf="getAdSpend(accounts) as adSpend">
                        <ng-container
                            *ngTemplateOutlet="currencySummationTmpl; context: { values: adSpend }"
                        ></ng-container>
                    </td>
                </ng-template>

                <ng-template let-month="month" #priceCalcTdTmpl>
                    <td *ngIf="getFinalPriceCalculation(planData, month, plan) as finalPrice">
                        <ng-container
                            *ngTemplateOutlet="currencyTmpl; context: { value: finalPrice.fee }"
                        ></ng-container>
                        +
                        <ng-container
                            *ngTemplateOutlet="currencyTmpl; context: { value: finalPrice.paidSales }"
                        ></ng-container>
                        x
                        {{ finalPrice.percentage | percent: '1.2-2' }}
                        <ng-container *ngIf="finalPrice.adSpend">
                            +
                            <ng-container
                                *ngTemplateOutlet="currencyTmpl; context: { value: finalPrice.adSpend }"
                            ></ng-container>
                            x
                            {{ getAdSpendPercentage(plan) | percent: '1.2-2' }}
                        </ng-container>
                    </td>
                </ng-template>

                <ng-template let-month="month" let-period="period" #invoiceTdCalc>
                    <td *ngIf="getFinalPrice(planData, month, period, plan) as invoiceTotal">
                        <strong *ngIf="period === SubscriptionInvoicePeriod.Yearly; else monthlyInvoiceTmpl">
                            <ng-container
                                *ngTemplateOutlet="currencyTmpl; context: { value: invoiceTotal }"
                            ></ng-container>
                        </strong>

                        <ng-template #monthlyInvoiceTmpl>
                            <ng-container
                                *ngTemplateOutlet="currencyTmpl; context: { value: invoiceTotal }"
                            ></ng-container>
                        </ng-template>
                    </td>
                </ng-template>
            </table>
        </nz-tab>
    </nz-tabset>

    <ng-template #currencyTmpl let-value="value">
        {{ value | microsToNumber | currency: currency : 'symbol' : '1.0-0' }}
    </ng-template>

    <ng-template #currencySummationTmpl let-values="values">
        <ng-container *ngFor="let value of values; let last = last">
            <ng-container *ngTemplateOutlet="currencyTmpl; context: { value }"></ng-container>
            <ng-container *ngIf="!last">&ngsp;+&ngsp;</ng-container>
        </ng-container>
    </ng-template>
</div>
